import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { Element } from '../../../../../common/html/element'
import { PopupAction } from '../../../../../common/popup/PopupAction'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import TextEllipsis from '../../../../../common/textEllipsis'
import { resetStoreHeaderCompanyAnalysis } from '../../../../../companyAnalysis/common/header/companyInfo/store/slice'
import { COMPONENTS } from '../../../../../routers/constants'
import { getPanelList } from '../../../helper'
import { mainTabs } from '../constant'
import classes from '../index.module.scss'
import {
  changeCompanyType,
  changeMainScreen,
  selectCompanyType,
  selectMainScreen,
} from '../store/slice'
import PanelItem from './PanelItem'
import SearchArea from './SearchArea'

const PanelList = () => {
  const dispatch = useDispatch()

  const navigate = useNavigate()

  const mainScreen = useSelector(selectMainScreen)
  const companyType = useSelector(selectCompanyType)

  const [panelList, setPanelList] = useState([])
  const [isShow, setIsShow] = useState(false)

  const newCompanyType = useRef('')

  useEffect(() => {
    setPanelList(getPanelList(mainScreen, companyType))
  }, [mainScreen, companyType])

  useEffect(() => {
    dispatch(resetStoreHeaderCompanyAnalysis())
  }, [companyType])

  useEffect(() => {
    return () => dispatch(resetStoreHeaderCompanyAnalysis())
  }, [])

  const onClickMainScreen = (value) => () => dispatch(changeMainScreen(value))

  const openPopup = ({ value }) => {
    if (value !== companyType) {
      newCompanyType.current = value
      setIsShow(true)
    }
  }

  const closePopup = () => {
    newCompanyType.current = ''
    setIsShow(false)
  }

  const submitChangeCompanyType = () => {
    dispatch(changeCompanyType(newCompanyType.current))
    navigate(COMPONENTS.dynamicReport.route)
    closePopup()
  }

  return (
    <div className={classes.panelList}>
      <div className="dFlex">
        {mainTabs.map(({ value, name }) => {
          const isActive = mainScreen === value
          return (
            <Element
              key={value}
              className={classes.mainTab}
              style={{
                backgroundColor: isActive ? '#2C73E8' : '#FFFFFF',
                color: isActive ? '#FFFFFF' : '#191D25',
              }}
              onClick={onClickMainScreen(value)}
            >
              <TextEllipsis text={name} />
            </Element>
          )
        })}
      </div>
      <SearchArea openPopup={openPopup} />
      <div className={classes.items}>
        <ScrollComponent>
          {panelList.map((panel, index) => {
            return (
              <PanelItem key={index + '' + mainScreen} item={panel} level={1} />
            )
          })}
        </ScrollComponent>
      </div>
      <PopupAction
        isShow={isShow}
        title="dynamicReport.CONFIRM"
        btnCancel={{
          label: 'dynamicReport.NO',
          isI18n: true,
          event: closePopup,
        }}
        btnSubmit={{
          label: 'dynamicReport.YES',
          isI18n: true,
          event: submitChangeCompanyType,
        }}
        handleClose={closePopup}
      >
        <Element style={{ color: '#3A414B' }}>
          <Translate value="dynamicReport.CHANGE_COMPANY_TYPE_ALERT" />
        </Element>
      </PopupAction>
    </div>
  )
}

export default PanelList
